import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { Intervento } from '../../../models/intervento.model';
import { InterventiService } from '../../../services/interventi.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-liquidazione-intervento',
  standalone: true,
  templateUrl: './liquidazione-intervento.component.html',
  styleUrls: ['./liquidazione-intervento.component.css'],
  imports: [CommonModule, FormsModule, DialogModule, ButtonModule, InputTextareaModule],
})
export class LiquidazioneInterventoComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() intervento: Intervento | null = null;
  @Output() liquidato = new EventEmitter<void>();

  dataLiquidazione: string | null = null;
  importoLiquidato: number = 0;
  note: string = '';
  salvataggioInCorso: boolean = false;

  constructor(
    private interventiService: InterventiService,
    private messageService: MessageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] || changes['intervento']) {
      if (this.visible && this.intervento) {
        const rendicontato = this.intervento.importoRendicontato ?? 0;
        const giàLiquidato = this.intervento.importoLiquidato ?? 0;
        this.importoLiquidato = Math.max(0, rendicontato - giàLiquidato);
        const oggi = new Date();
        this.dataLiquidazione = oggi.toISOString().substring(0, 10);
        this.note = '';
      }
    }
  }

  hide(): void {
    if (this.salvataggioInCorso) {
      return;
    }
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  confermaLiquidazione(): void {
    if (!this.dataLiquidazione || !this.intervento || !this.intervento.id) {
      return;
    }

    this.salvataggioInCorso = true;

    const payload = {
      importo: this.importoLiquidato,
      dataLiquidazione: `${this.dataLiquidazione}T00:00:00`,
      note: this.note,
    };

    this.interventiService.liquidaIntervento(this.intervento.id, payload).subscribe({
      next: () => {
        this.salvataggioInCorso = false;
        this.liquidato.emit();
        this.hide();
        this.messageService.add({
          severity: 'success',
          summary: 'Liquidazione registrata',
          detail: 'La liquidazione dell\'intervento è stata salvata con successo.',
          life: 4000,
        });
      },
      error: (error) => {
        console.error('[LIQUIDAZIONE INTERVENTO] Errore nella liquidazione', error);
        this.salvataggioInCorso = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore durante il salvataggio della liquidazione.',
          life: 5000,
        });
      },
    });
  }
}
